// extracted by mini-css-extract-plugin
export var banner = "_cb-0";
export var closeButton = "_cb-2";
export var greenCheckmark = "_cb-3";
export var hereLink = "_cb-4";
export var titleIcon = "_cb-1";